import { render, staticRenderFns } from "./ConfiguracaoAprovacao.vue?vue&type=template&id=8903065e&"
import script from "./ConfiguracaoAprovacao.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoAprovacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports